import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';

// Routes
import Home from 'views/Home.vue';
import Company from 'views/Company.vue';
import Studios from 'views/Studios.vue';
import Tutorials from 'views/Tutorials.vue';
import CaseStudies from 'views/CaseStudies.vue';
import Gallery from 'views/Gallery.vue';
import Flixel from 'views/Flixel.vue';
import Profile from 'views/Profile.vue';
import Settings from 'views/Settings.vue';
import ManageSettings from 'views/ManageSettings.vue';
import PageNotFound from 'views/404.vue';
// Product views
import MacFCP from 'views/products/mac-fcp.vue';
import iOSFCP from 'views/products/ios-fcp.vue';
import macFPS from 'views/products/mac-fps.vue';
import blendeo from 'views/products/blendeo.vue';
import hosting from 'views/products/hosting.vue';
import pricing from 'views/products/pricing.vue';
import success from 'views/products/productSuccess.vue';
import enterprise from 'views/products/enterprise.vue';
// Landing Page views
import buzzoole from 'views/landingPages/influencer/buzzoole/buzzoole.vue';
import ello from 'views/landingPages/influencer/ello/ello.vue';
import whalar from 'views/landingPages/influencer/whalar/whalar.vue';
import affiliate from 'views/landingPages/affiliate/affiliate.vue';
import perks500 from 'views/landingPages/offers/500perks/500perks.vue';
import dollardeal from 'views/landingPages/offers/fb/1dollardeal.vue';
import pond5 from 'views/landingPages/offers/pond5/pond5.vue';
// Legal views
import Privacy from 'views/legal/Privacy.vue';
import Terms from 'views/legal/Terms.vue';
import SalesPolicy from 'views/legal/SalesPolicy.vue';
// Auth views
import Login from 'views/auth/Login.vue';
import Register from 'views/auth/Register.vue';
import ForgotPassword from 'views/auth/ForgotPassword.vue';

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/company',
      name: 'Company',
      component: Company,
    },
    // Product views
    {
      path: '/products/mac/cinemagraph-pro/',
      name: 'Mac-FCP',
      component: MacFCP,
    },
    {
      path: '/products/mac/cinemagraph-pro/buy/complete/',
      name: 'Mac-FCP-success',
      component: success,
      props: {
        productKey: 'fcpmac',
        otherProducts: ['fcpios', 'fpsmac'],
      },
    },
    {
      path: '/products/ios/cinemagraph-pro/',
      name: 'iOS-FCP',
      component: iOSFCP,
    },
    {
      path: '/products/ios/cinemagraph-pro/buy/complete/',
      name: 'iOS-FCP-success',
      component: success,
      props: {
        productKey: 'fcpios',
        otherProducts: ['fcpmac', 'fpsmac'],
      },
    },
    {
      path: '/products/ios/blendeo/',
      name: 'Blendeo',
      component: blendeo,
    },
    {
      path: '/products/ios/blendeo/buy/complete/',
      name: 'blendeo-success',
      component: success,
      props: {
        productKey: 'blendeo-year',
        otherProducts: ['fcpmac', 'fcpios', 'fpsmac'],
      },
    },
    {
      path: '/products/mac/persecond/',
      name: 'Mac-FPS',
      component: macFPS,
    },
    {
      path: '/products/mac/persecond/buy/complete/',
      name: 'mac-fps-success',
      component: success,
      props: {
        productKey: 'fpsmac-year',
      },
    },
    {
      path: '/products/mac/persecond/buy/complete/',
      name: 'mac-fps-license-success',
      component: success,
      props: {
        productKey: 'fpsmac',
        otherProducts: ['fcpmac', 'fcpios'],
      },
    },
    {
      path: '/products/hosting/',
      name: 'hosting',
      component: hosting,
    },
    {
      path: '/products/pricing/',
      name: 'pricing',
      component: pricing,
    },
    {
      path: '/products/flixel-cloud/webapps/buy/complete/',
      name: 'mac-fcwa-success',
      component: success,
      props: {
        productKey: 'fcwa',
        otherProducts: ['fcpmac', 'fcpios', 'fpsmac'],
      },
    },
    {
      path: '/products//flixel-cloud/web/buy/complete/',
      name: 'mac-fcw-success',
      component: success,
      props: {
        productKey: 'fcw',
        otherProducts: ['fcpmac', 'fcpios', 'fpsmac'],
      },
    },
    {
      path: '/products/flixel-plan/business/buy/complete/',
      name: 'business-success',
      component: success,
      props: {
        productKey: 'fbp-y',
        otherProducts: ['fcpmac', 'fcpios', 'fpsmac', 'blendeo'],
      },
    },
    {
      path: '/products/flixel-plan/professional/buy/complete/',
      name: 'professional-success',
      component: success,
      props: {
        productKey: 'fpp-y',
        otherProducts: ['fcpmac', 'fcpios', 'blendeo'],
      },
    },
    {
      path: '/products/flixel-plan/mobile/buy/complete/',
      name: 'mobile-success',
      component: success,
      props: {
        productKey: 'fmp-y',
        otherProducts: ['fcpios', 'blendeo'],
      },
    },
    {
      path: '/enterprise/',
      name: 'enterprise',
      component: enterprise,
    },
    // Landing Page Paths
    {
      path: '/lp/influencer/buzzoole',
      name: 'buzzoole',
      component: buzzoole,
    },
    {
      path: '/lp/influencer/ello',
      name: 'ello',
      component: ello,
    },
    {
      path: '/lp/influencer/whalar',
      name: 'whalar',
      component: whalar,
    },
    {
      path: '/lp/affiliate',
      name: 'affiliate',
      component: affiliate,
    },
    {
      path: '/lp/500perks',
      name: '500perks',
      component: perks500,
    },
    {
      path: '/lp/1dollardeal',
      name: '1dollardeal',
      component: dollardeal,
    },
    {
      path: '/lp/pond5',
      name: 'pond5',
      component: pond5,
    },
    // Legal Paths
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
    },
    {
      path: '/sales-policy',
      name: 'SalesPolicy',
      component: SalesPolicy,
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
    },
    // Auth Path
    {
      path: '/login/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/registration/',
      name: 'Register',
      component: Register,
    },
    {
      path: '/forgot-password/',
      name: 'ForgotPassword',
      component: ForgotPassword,
    },
    // Studios
    {
      path: '/studios/',
      name: 'Studios',
      component: Studios,
    },
    // Tutorials
    {
      path: '/tutorials/',
      name: 'Tutorials',
      component: Tutorials,
    },
    {
      path: '/case-studies/',
      name: 'Case Studies',
      component: CaseStudies,
    },
    // Gallery
    {
      path: '/cinemagraphs/',
      redirect: '/cinemagraphs/fresh',
    },
    {
      path: '/cinemagraphs/:gallery_name/',
      name: 'Gallery',
      component: Gallery,
      props: true,
    },
    {
      path: '/cinemagraph/:hash/',
      name: 'Flixel',
      component: Flixel,
      props: true,
    },
    // 404
    {
      path: '/404/',
      component: PageNotFound,
    },
    {
      path: '*',
      redirect: '/404/',
    },
    // User settings
    {
      path: '/settings/account/',
      name: 'Settings',
      component: Settings,
    },
    {
      path: '/settings/flixel-cloud/manage/',
      name: 'Manage settings',
      component: ManageSettings,
    },
    // Watermark List
    {
      path: '/watermarks/',
      name: 'Watermarks',
      redirect: '404',
    },
    // Edit Watermarks
    {
      path: '/watermark/',
      name: 'Edit Watermarks',
      redirect: '404',
    },
    // User Profile
    // This needs to be at the bottom of the routing list
    {
      path: '/:username/',
      name: 'Profile',
      component: Profile,
      props: true,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js